<section class="configuration-workspace">
  @if (loading) {
    <div class="configuration-loading"><span class="spinner-border"></span></div>
  }
  @if (error) {
    <div class="alert alert-danger">{{ error | translate }}</div>
  }
  @if (saved) {
    <div class="alert alert-success">{{ 'CONFIGURATION_SAVED' | translate }}</div>
  }

  @if (amazon) {
    <div class="configuration-heading">
      <div>
        <span class="eyebrow">{{ 'AMAZON_FINANCE' | translate }}</span>
        <h2>{{ 'FINANCE_IMPORT_CONFIGURATION' | translate }}</h2>
        <p>{{ 'FINANCE_CONFIGURATION_HELP' | translate }}</p>
      </div>
      <div class="configuration-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="validate()">
          <i class="fa-solid fa-shield-check"></i> {{ 'VALIDATE' | translate }}</button
        ><button type="button" class="btn btn-primary" [disabled]="saving" (click)="save()">
          <span *ngIf="saving" class="spinner-border spinner-border-sm"></span> {{ 'SAVE_CONFIGURATION' | translate }}
        </button>
      </div>
    </div>

    <div class="configuration-grid">
      <div class="configuration-main">
        <article class="config-card">
          <header>
            <i class="fa-solid fa-calendar-range"></i>
            <div>
              <h3>{{ 'IMPORT_WINDOW' | translate }}</h3>
              <p>{{ 'IMPORT_WINDOW_HELP' | translate }}</p>
            </div>
          </header>
          <div class="field-grid">
            <label
              ><span>{{ 'HISTORY_DAYS' | translate }}</span
              ><small>{{ 'HISTORY_DAYS_HELP' | translate }}</small
              ><input
                class="form-control"
                type="number"
                min="-3650"
                max="-1"
                [(ngModel)]="amazon.syncFinanceTransactionsDaysBack"
            /></label>
            <label
              ><span>{{ 'CREATE_FROM' | translate }}</span
              ><input class="form-control" type="date" [(ngModel)]="amazon.createDocumentsFromDate"
            /></label>
            <label
              ><span>{{ 'CREATE_TO' | translate }}</span
              ><input class="form-control" type="date" [(ngModel)]="amazon.createDocumentsToDate"
            /></label>
            <label
              ><span>{{ 'DEFAULT_ASSORTMENT' | translate }}</span
              ><input class="form-control" [(ngModel)]="amazon.defaultAssortment"
            /></label>
            <label
              ><span>{{ 'DEFAULT_PRODUCT' | translate }}</span
              ><input class="form-control" [(ngModel)]="amazon.defaultProductId"
            /></label>
          </div>
        </article>

        <article class="config-card">
          <header>
            <i class="fa-solid fa-arrow-right-arrow-left"></i>
            <div>
              <h3>{{ 'FINANCE_MAPPINGS' | translate }}</h3>
              <p>{{ 'KEY_VALUE_HELP' | translate }}</p>
            </div>
          </header>
          <div class="map-grid">
            @for (field of mapFields; track field.key) {
              <label
                ><span>{{ field.label | translate }}</span
                ><small>{{ field.hint }}</small
                ><textarea class="form-control code-input" rows="5" [(ngModel)]="mapText[field.key]"></textarea>
              </label>
            }
          </div>
        </article>

        <article class="config-card">
          <header>
            <i class="fa-solid fa-brackets-curly"></i>
            <div>
              <h3>{{ 'HEADER_MAPPINGS' | translate }}</h3>
              <p>{{ 'HEADER_MAPPINGS_HELP' | translate }}</p>
            </div>
          </header>
          <div class="map-grid map-grid--two">
            <label
              ><span>{{ 'CUSTOMER_REVENUE_HEADERS' | translate }}</span
              ><textarea class="form-control code-input" rows="10" [(ngModel)]="customerRevenueHeaders"></textarea>
            </label>
            <label
              ><span>{{ 'AMAZON_FEE_HEADERS' | translate }}</span
              ><textarea class="form-control code-input" rows="10" [(ngModel)]="amazonFeeHeaders"></textarea>
            </label>
          </div>
        </article>
      </div>

      <aside class="configuration-side">
        <article class="config-card validation-card">
          <header>
            <i class="fa-solid fa-stethoscope"></i>
            <div>
              <h3>{{ 'CONFIGURATION_HEALTH' | translate }}</h3>
              <p>{{ 'LIVE_VALIDATION_RESULTS' | translate }}</p>
            </div>
          </header>
          <div class="health-section">
            <strong>Amazon</strong>
            @if (!validation?.errors?.length && !validation?.warnings?.length) {
              <p class="health-ok"><i class="fa-solid fa-circle-check"></i> {{ 'VALID_CONFIGURATION' | translate }}</p>
            }
            @for (message of validation?.errors || []; track message) {
              <p class="health-error"><i class="fa-solid fa-circle-xmark"></i> {{ message }}</p>
            }
            @for (message of validation?.warnings || []; track message) {
              <p class="health-warning"><i class="fa-solid fa-triangle-exclamation"></i> {{ message }}</p>
            }
          </div>
        </article>
      </aside>
    </div>

    <div class="sticky-save">
      <span>{{ 'CONFIGURATION_AUDITED' | translate }}</span>
      <div>
        <button type="button" class="btn btn-outline-secondary" (click)="validate()">
          {{ 'VALIDATE' | translate }}</button
        ><button type="button" class="btn btn-primary" [disabled]="saving" (click)="save()">
          {{ 'SAVE_CONFIGURATION' | translate }}
        </button>
      </div>
    </div>
  }
</section>
